import { defineAction } from '_utils/redux'

export const SET_SEARCH_FILTER = defineAction('SET_SEARCH_FILTER')

export const setSearchFilter = payload => dispatch =>
  dispatch({
    type: SET_SEARCH_FILTER.ACTION,
    payload: new Promise(res => res(payload)),
  })
